/* unplugin-vue-components disabled */import { render } from "./potatoNew.vue?vue&type=template&id=2ab15450&scoped=true"
import script from "./potatoNew.vue?vue&type=script&lang=js"
export * from "./potatoNew.vue?vue&type=script&lang=js"

import "./potatoNew.vue?vue&type=style&index=0&id=2ab15450&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab15450"]])

export default __exports__